export const DEFAULT_BUSINESS_PROFILE_QUESTIONS = [
  {
    title: "About your business",
    description: "A few quick details help us tailor your setup.",
    questions: [
      {
        id: "businessStage",
        label: "Where is your business today?",
        type: "select",
        options: [
          "Still an idea",
          "Newly established",
          "Already operating",
          "Expanding online",
        ],
      },
      {
        id: "productsAndServices",
        label: "What do you plan to sell?",
        type: "textarea",
        placeholder: "A short description is perfect",
      },
      {
        id: "onlineSellingExperience",
        label: "Have you sold online before?",
        type: "select",
        options: [
          "Yes, through an online store",
          "Yes, through WhatsApp or social media",
          "No, this is my first time",
        ],
      },
    ],
  },
  {
    title: "Readiness and customers",
    description: "Tell us what is ready and who you want to reach.",
    questions: [
      {
        id: "productsReady",
        label: "Are your products and listing details ready, and how many will you start with?",
        type: "select",
        options: [
          "Ready — 1 to 5 products",
          "Ready — 6 to 20 products",
          "Ready — more than 20 products",
          "Partially ready",
          "Not ready yet",
        ],
      },
      {
        id: "targetCustomers",
        label: "Who are your target customers, and where are they located?",
        type: "textarea",
      },
      {
        id: "marketingPlan",
        label: "How do you expect to attract customers?",
        type: "select",
        options: [
          "Social media or word of mouth",
          "Paid advertising",
          "A mix of organic and paid marketing",
          "I need help deciding",
        ],
      },
    ],
  },
  {
    title: "Launch and support",
    description: "We’ll use your answers to plan the right next steps.",
    questions: [
      {
        id: "supportAreas",
        label: "Where would you most like help?",
        type: "multi-select",
        options: [
          "Store setup",
          "Adding products and prices",
          "Payments",
          "Delivery",
          "Managing orders",
          "Marketing",
          "Other",
        ],
      },
      {
        id: "targetLaunchDate",
        label: "When would you like to launch your store?",
        type: "date",
      },
      {
        id: "subscriptionUnderstood",
        label: "Are your plan cost, renewal and cancellation terms clear?",
        type: "select",
        options: ["Yes", "I would like someone to explain them"],
      },
    ],
  },
];

export const parseBusinessProfileQuestions = (value) => {
  if (!value) return DEFAULT_BUSINESS_PROFILE_QUESTIONS;

  let parsed = value;
  if (typeof value === "string") {
    parsed = JSON.parse(value);
  }

  if (
    !Array.isArray(parsed) ||
    parsed.some(
      (section) =>
        !section ||
        typeof section.title !== "string" ||
        !Array.isArray(section.questions),
    )
  ) {
    throw new Error("Business profile questions have an invalid format.");
  }

  return parsed;
};
